import { useEffect, useState } from 'react';

export const useHoverDropdownMenu = (): [
  {
    isOpen: boolean;
    isTriggerHovered: boolean;
    isMenuHovered: boolean;
  },
  React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      isTriggerHovered: boolean;
      isMenuHovered: boolean;
    }>
  >,
] => {
  const [menuState, setMenuState] = useState({
    isOpen: false,
    isTriggerHovered: false,
    isMenuHovered: false,
  });

  useEffect(() => {
    if (!menuState.isMenuHovered && !menuState.isTriggerHovered && menuState.isOpen) {
      setTimeout(
        () =>
          setMenuState((curStatus) => ({
            ...curStatus,
            isOpen: curStatus.isTriggerHovered || curStatus.isMenuHovered,
          })),
        100
      );
    }
    if ((menuState.isMenuHovered || menuState.isTriggerHovered) && !menuState.isOpen) {
      setTimeout(
        () =>
          setMenuState((curStatus) => ({
            ...curStatus,
            isOpen: curStatus.isTriggerHovered || curStatus.isMenuHovered,
          })),
        100
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuState.isMenuHovered, menuState.isTriggerHovered]);

  return [menuState, setMenuState];
};
